import {
  Email as EmailIcon,
  MoreHoriz as MoreHorizIcon
} from "@mui/icons-material";
import {
  Box,
  Card,
  Checkbox,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { getAllBudgets } from "../../services/budgetService";
import { getEmail } from "../../services/emailService";
import BudgetDetailsControlCanalDireto from "./budgetRequestDetails/BudgetDetailsControlCanalDireto";
import BudgetRequestModalFilterCanalDireto from "./BudgetRequestModalFilterCanalDireto";


const BudgetRequestListCanalDireto = ({
  // budgets,
  handleChangeFilteredStatus,
  selectedCustomerIds,
  setSelectedCustomerIds,
  isFilter,
  setIsFilter,
  setQuantityFiltered,
  changeFilter,
  filter: params,
  ...rest
}) => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const [budgets, setBudgets] = useState([]);
  const [totalBudgets, setTotalBudgets] = useState(0);

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedBudget, setSelectedBudget] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [emailData, setEmailData] = useState('');

  const handleOpenDetails = (budget) => {
    setSelectedBudget(budget);
    setDetailsModalOpen(true);
  };

  const format = (price) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(price);

  useEffect(() => {
    fetchBudgets();
  }, [page, limit, isFilter, params]);

  const fetchBudgets = () => {
    getAllBudgets({ page, limit, budget_type: 2, filter: params })
      .then(({ data, totalBudgets: count }) => {
        setBudgets(data);
        setTotalBudgets(count);
      });

    setQuantityFiltered(
      Object.values(params).filter(
        x => x !== '' && x !== 0 && x !== null && x?.length > 0
      ).length
    );
  };


  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;

    if (event.target.checked) {
      newSelectedCustomerIds = budgets.map((product) => product.id);
    } else {
      newSelectedCustomerIds = [];
    }

    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCustomerIds.indexOf(id);
    let newSelectedCustomerIds = [];

    if (selectedIndex === -1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(1)
      );
    } else if (selectedIndex === selectedCustomerIds.length - 1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, selectedIndex),
        selectedCustomerIds.slice(selectedIndex + 1)
      );
    }

    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1200,
    height: '95%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'center',
  };

  const tableCellStyle = {
    textAlign: 'center'
  }

  const handleOpenEmailModal = async (email) => {
    const data = await getEmail({fileName: email});
    data && setEmailData(data);
    setModalOpen(!modalOpen);
  };

  return (
    <Card {...rest}>
      <Box sx={{ minWidth: 1050 }}>
        <Table size={"small"}>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedCustomerIds.length === budgets.length}
                  color="primary"
                  indeterminate={
                    selectedCustomerIds.length > 0 &&
                    selectedCustomerIds.length < budgets.length
                  }
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell sx={tableCellStyle}>Cliente</TableCell>
              <TableCell sx={tableCellStyle}>Status</TableCell>
              <TableCell sx={tableCellStyle}>Responsável</TableCell>
              <TableCell sx={tableCellStyle}>Agência</TableCell>
              <TableCell sx={tableCellStyle}>Estado</TableCell>
              <TableCell sx={tableCellStyle}>Executivo</TableCell>
              <TableCell sx={tableCellStyle}>Motivo</TableCell>
              <TableCell sx={tableCellStyle}>Data de Envio</TableCell>
              {/*<TableCell>Ações</TableCell>*/}
              <TableCell sx={tableCellStyle}>Ver E-mail</TableCell>
              <TableCell sx={tableCellStyle}>Detalhes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {budgets.slice(0, limit).map((budget, i) => (
              <TableRow
                hover
                key={i}
                selected={selectedCustomerIds.indexOf(budget.id) !== -1}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedCustomerIds.indexOf(budget.id) !== -1}
                    onChange={(event) => handleSelectOne(event, budget.id)}
                    value="true"
                  />
                </TableCell>
                <TableCell sx={tableCellStyle}>{budget.client}</TableCell>
                <TableCell sx={tableCellStyle}>
                  <Typography variant="h2" sx={{ fontWeight: 600, display: "flex", alignItems: "center", gap: "10px", justifyContent: "center"}}>
                    <Box
                      component="span"
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        bgcolor: budget.budget_status.color,
                        flexShrink: 0
                      }}
                    />
                  </Typography>
                </TableCell>
                <TableCell sx={tableCellStyle}>{budget.clerk}</TableCell>
                <TableCell sx={tableCellStyle}>{budget.agencia}</TableCell>
                <TableCell sx={tableCellStyle}>{budget.estado}</TableCell>
                <TableCell sx={tableCellStyle}>{budget.executivo}</TableCell>
                <TableCell sx={tableCellStyle}>
                  {budget.ds_status}
                </TableCell>
                <TableCell sx={tableCellStyle}>
                  {budget.created_at}
                </TableCell>
                <TableCell sx={tableCellStyle}>
                  {budget?.emailFileName && (
                    <IconButton
                        onClick={(_) => handleOpenEmailModal(budget?.emailFileName)}
                        aria-label="EmailIcon"
                    >
                        <EmailIcon fontSize="medium" />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell sx={tableCellStyle}>
                  <IconButton
                      onClick={(_) => handleOpenDetails(budget)}
                      aria-label="EmailIcon"
                  >
                    <MoreHorizIcon fontSize="medium" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <TablePagination
        component="div"
        count={totalBudgets}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        labelRowsPerPage={`${budgets.length} registros encontrados`}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
        }
        rowsPerPageOptions={[5, 10, 25]}
      />
      <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div dangerouslySetInnerHTML={{__html: emailData}} />
        </Box>
      </Modal>
      <BudgetRequestModalFilterCanalDireto
          open={isFilter}
          onClose={() => setIsFilter(false)}
          setIsFilter={setIsFilter}
          changeFilter={changeFilter}
          params={params}
      />
      <Modal
        open={detailsModalOpen}
        onClose={() => setDetailsModalOpen(false)}
        aria-labelledby="modal-budget-details"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 1200,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          overflowY: 'auto',
          overflowX: 'hidden',
          maxHeight: '90%'
        }}>
          {selectedBudget && <BudgetDetailsControlCanalDireto budget={selectedBudget} fetchBudgets={fetchBudgets}/>}
        </Box>
      </Modal>
    </Card>
  );
};

BudgetRequestListCanalDireto.propTypes = {
  budgets: PropTypes.array.isRequired,
};

export default BudgetRequestListCanalDireto;
